import { render, staticRenderFns } from "./SplitPanelModal.vue?vue&type=template&id=7c3477cf&scoped=true&"
import script from "./SplitPanelModal.vue?vue&type=script&lang=js&"
export * from "./SplitPanelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3477cf",
  null
  
)

export default component.exports